import type { RouterReducerState } from '@ngrx/router-store';
import { getRouterSelectors } from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';

export const ROUTER_FEATURE_KEY = 'router';

export const selectRouter = createFeatureSelector<RouterReducerState>(ROUTER_FEATURE_KEY);

export const {
    selectCurrentRoute, // Select the current route
    selectFragment, // Select the current route fragment
    selectQueryParams, // Select the current route query params
    selectQueryParam, // Factory function to select a query param
    selectRouteParams, // Select the current route params
    selectRouteParam, // Factory function to select a route param
    selectRouteData, // Select the current route data
    selectUrl, // Select the current url
} = getRouterSelectors(selectRouter);
